import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { saveData } from '../../services/resultHelper'
import ValidateButton from '../ValidateButton/ValidateButton'
import { tag } from '../../services/ATInternetService'
import { ResultStore } from 'src/store/ResultStore'

class StepFinish extends React.Component<RouteComponentProps> {
  public render() {
    return (
      <>
        <div className="Row Row--mw500">
          <p>Merci pour vos réponses.</p>
        </div>
        <div className="control-color-wrapper">
          <ValidateButton
            onClick={this.sendToKuzzle}
            validateLabel="Je découvre mon bilan personnalisé"
            finishStepAction={true}
          />
        </div>
      </>
    )
  }

  private sendToKuzzle = (e) => {
    e.preventDefault()
    tag.sendPage({
      elem: this,
      name: 'alcoometre_ok',
      chapter1: 'Questionnaire',
    })
    ResultStore.calculateResults()
    saveData(() => {
      this.props.history.push('/results')
    })
  }
}

export default withRouter(StepFinish)



// WEBPACK FOOTER //
// ./src/components/StepFinish/StepFinish.tsx